import React from "react";

const Pantalon3 = ({ fillColor = "#FFDFC4", strokeColor = "#000000" }) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 408 1220">
		<defs>
			<style>
				{`.cls-1 { fill: none; } .cls-2 { stroke-miterlimit: 10; }`}
			</style>
		</defs>
		<title>Base</title>
		<g id="cadre">
			<rect className="cls-1" width={408} height={1220} />
		</g>
		<g id="base">
			<path
				id="frame_1"
				data-name="frame 1"
				className="cls-2"
				fill={fillColor} // 👈 Apply dynamic fill color
				stroke={strokeColor} // 👈 Apply dynamic stroke color
				d="M1000.5,955.5s-9.27,51.84-20.58,115c4.58,1,3.58,13-4.42,24.69-16.32,91-34.81,193.88-36,199.33-7,32-24,201-13,265,30,13,57,5,57,5s45-214,47-246,39-180,39-180,7,43,0,102,30,317,30,317,47,6,75-25c-6-39-6-126,0-185s0-61,0-104-5-236-18-276C1147.5,936.5,1000.5,955.5,1000.5,955.5Z"
				transform="translate(-878.5 -427.5)"
			/>
		</g>
	</svg>
);

export default Pantalon3;
